import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class PostPackageService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getDatatable({skip, limit, sort, desc, region, area, client, start, end, postIndex, courier}) {
        return Vue.axios.get(`${APIHOST}/api/PostPackageDataTable`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                limit: limit,
                skip: skip,
                sort: sort,
                desc: desc,
                client: client ? client.id : null,
                region: region ? region.id : null,
                area: area ? area.id : null,
                start: start ? start.format('YYYY-MM-DD') : null,
                end: end ? end.format('YYYY-MM-DD') : null,
                postIndex: postIndex ? postIndex : null,
                courier: courier
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    get(uid) {
        return Vue.axios.get(`${APIHOST}/api/PostPackage`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getMails(uid) {
        return Vue.axios.get(`${APIHOST}/api/PostPackageMail`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getPdfPath(postPackage) {
        return `${APIHOST}/api/PostPackagePdf/${postPackage.uid}`
    }

    getPdf(postPackage) {
        return Vue.axios.get(`${APIHOST}/api/PostPackagePdf`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: postPackage.uid
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    changePostCode({postPackage, postCode}) {
        return Vue.axios.put(`${APIHOST}/api/ChangePostPackagePostCode`, {
            PostCode: postCode
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: postPackage.uid
            }
        })
    }

    create({region, postCode, client, courier}) {
        return Vue.axios.post(`${APIHOST}/api/PostPackage`, {
            RegionId: region.id,
            PostCode: postCode,
            Client: client.id,
            Courier: courier ? courier : null,
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }
}

export default new PostPackageService()